import {
  EventBaseInfo,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { Activity } from './activity-history-configuration';

export class ItineraryActivityHeaderConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryActivityHeaderConfiguration';
  nodataLocalizationKeyName = 'activityHeader';
  readonly reportSection = ReportSection.ItineraryActivityHeader;
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly applicableReportTypes = [ReportType.Itinerary];
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_ActivityHeader];

  maxSize = 3;
  defaultSize = 3;
  minSize = 3;
  override disabledLayoutWidthControl = true;
  name = 'activityHeader';
  override disableSectionSelection = true;
  // todo:  need to update these subsections with original datapoints
  readonly availableDataSections = [
    {
      name: 'activityHeaderDate',
      displayName: 'Date',
      isSelected: true,
      canConfigure: false,
      property: 'date',
      isStatic: true
    },
    {
      name: 'activityHeaderTime',
      displayName: 'Time',
      isSelected: true,
      canConfigure: false,
      property: 'time',
      isStatic: true
    },
    {
      name: 'activityHeaderTimeZone',
      displayName: 'Timezone',
      isSelected: true,
      canConfigure: true,
      property: 'timezone'
    },
    {
      name: 'activityHeaderLocation',
      displayName: 'Location',
      isSelected: true,
      canConfigure: true,
      property: 'location'
    },
    {
      name: 'activityHeaderSubject',
      displayName: 'Subject',
      isSelected: true,
      canConfigure: true,
      property: 'subject'
    },
    {
      name: 'activityHeaderActivityType',
      displayName: 'Activity Type',
      isSelected: true,
      canConfigure: true,
      property: 'activityType'
    },
    {
      name: 'activityHeaderEvent',
      displayName: 'Event',
      isSelected: true,
      canConfigure: true,
      property: 'eventName',
      icon: 'f-i f-i-sm f-i-info'
    }
  ];

  get displayName(): string {
    if (this.appliedReportType === ReportType.Itinerary) {
      return 'Activity Header';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}
export interface ActivityHeader {
  dateRange: string;
  activity: Activity;
}

export interface ActivityHeaderData {
  [ReportViewModelSection.Itinerary_ActivityHeader]: ActivityHeader;
  [ReportViewModelSection.Itinerary_EventBaseInfo]: EventBaseInfo;
}
